import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: { name: 'login' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/layout.vue'),
    children: [
      {
        path: 'community',
        name: 'community',
        component: () => import('../views/community.vue'),
      },
      {
        path: 'evaluation',
        name: 'evaluation',
        component: () => import('../views/evaluation.vue'),
      },
      {
        path: 'parkManage',
        name: 'parkManage',
        component: () => import('../views/parkManage.vue'),
      },
      {
        path: 'building',
        name: 'building',
        component: () => import('../views/building.vue'),
      },
      {
        path: 'communityJob',
        name: 'communityJob',
        component: () => import('../views/communityJob.vue'),
      },
      {
        path: 'enterpriseJob',
        name: 'enterpriseJob',
        component: () => import('../views/enterpriseJob.vue'),
      },
      {
        path: 'appealList',
        name: 'appealList',
        component: () => import('../views/appealList.vue'),
      },
      {
        path: 'authorization',
        name: 'authorization',
        component: () => import('../views/authorization.vue'),
      },
      {
        path: 'review',
        name: 'review',
        component: () => import('../views/review.vue'),
      },
      {
        path: 'roleManagement',
        name: 'roleManagement',
        component: () => import('../views/roleManagement.vue'),
      },
      {
        path: 'systemLog',
        name: 'systemLog',
        component: () => import('../views/systemLog.vue'),
      },
      {
        path: 'changePassword',
        name: 'changePassword',
        component: () => import('../views/changePassword.vue'),
      },
      {
        path: 'businessApplicationCenter',
        name: 'businessApplicationCenter',
        component: () => import('../views/businessApplicationCenter.vue'),
      },
      {
        path: 'buildingUploadLog',
        name: 'buildingUploadLog',
        component: () => import('../views/buildingUploadLog.vue'),
      },
      {
        path: 'announcement',
        name: 'announcement',
        component: () => import('../views/announcement/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router